import { IModuleState } from './types';
import { IActionFn } from '@/store/types';
import { $http } from '@/axios';

// 查询所有品牌企业
export const queryBrandOrgs: IActionFn<IModuleState> = async ({ commit, state }) => {
  try {
    commit('setBrandOrgs', { ...state.brandOrgs, loading: true });
    // const res: any[] = await $http.post('/v1/data/system/org/brandorglist', {});
    const res: any[] = await $http.post('/v1/data/system/org/brandowners', {});
    const data = res.map((item) => ({ ...item, name: item.name || item.nickName || item.loginName }));
    commit('setBrandOrgs', { data });
  } catch (e) {
    commit('setBrandOrgs', { data: [] });
  }
};

// 查询品牌企业的下辖品牌列表
export const queryOrgBrands: IActionFn<IModuleState> = async ({ commit, state }, payload) => {
  try {
    commit('setOrgBrands', { ...state.orgBrands, loading: true });
    // const res = await $http.post('/v1/data/system/org/brandorgbrandlist', payload);
    const res = await $http.post('/v1/data/system/org/myownedbrands', payload);
    commit('setOrgBrands', { data: res });
  } catch (e) {
    commit('setOrgBrands', { data: [] });
  }
};

// 查询品牌门店列表
export const queryBrandStores: IActionFn<IModuleState> = async ({ commit }, payload) => {
  try {
    commit('setBrandStores', { data: [], loading: true });
    const res = await $http.post('/v1/data/system/org/digitalstorelist', payload);
    commit('setBrandStores', { data: res });
  } catch (e) {
    commit('setBrandStores', { data: [] });
  }
};

// 查询品牌门店下的品牌列表
export const queryStoreBrands: IActionFn<IModuleState> = async ({ commit }, payload) => {
  try {
    commit('setStoreBrands', { data: [], loading: true });
    const res = await $http.post('/v1/data/system/org/digitalstorebrandlist', payload);
    commit('setStoreBrands', { data: res });
  } catch (e) {
    commit('setStoreBrands', { data: [] });
  }
};

// 删除品牌门店和品牌企业的绑定关系
export const deleteBrandStore: IActionFn<IModuleState> = async ({ commit, state }, payload) => {
  try {
    commit('setConfirm', { ...state.confirm, loading: true });
    await $http.post('/v1/system/org/saveorupdatestore', payload);
  } finally {
    commit('setConfirm', { visible: false });
  }
};
